// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"a8a9d759bc41e564d7c8","293":"9f685be640171c0b2bc4","518":"3c46a411a404e88a196d","779":"33f29b6926fb1269ed2e"}[chunkId] + ".js";
};